/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const productDetailsCarouselMainImageSX: SxProps = {
	display:'block'
};

export const productDetailTopLeftRibbonSX ={
	position:'absolute',
	top:8,
	zIndex:2,
	'& img':{
		maxHeight:30,
	}
}
export const productDetailTopLeftRibbonSX2 ={
	position:'absolute',
	top:50,
	zIndex:2,
	'& img':{
		maxHeight:30,
	}
}

export const productDetailTopRightRibbonSX ={
	position:'absolute',
	top:8,
	right:0,
	zIndex:2,
	'& img':{
		maxHeight:50,
	}
}

export const productDetailBottomLeftRibbonSX ={
	position:'absolute',
	bottom:8,
	left:0,
	zIndex:2,
	'& img':{
		maxHeight:30,
	}
}